import { render } from "./LesProfesseurs.vue?vue&type=template&id=79edb13e&scoped=true&ts=true"
import script from "./LesProfesseurs.vue?vue&type=script&lang=ts"
export * from "./LesProfesseurs.vue?vue&type=script&lang=ts"

import "./LesProfesseurs.vue?vue&type=style&index=0&id=79edb13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79edb13e"]])

export default __exports__